/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, TagValueTypeFromJSON, TagValueTypeToJSON, } from './';
export function TagResponseFromJSON(json) {
    return TagResponseFromJSONTyped(json, false);
}
export function TagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'valueType': TagValueTypeFromJSON(json['valueType']),
        'predefinedValuesOnly': json['predefinedValuesOnly'],
        'predefinedValues': !exists(json, 'predefinedValues') ? undefined : json['predefinedValues']
    };
}
export function TagResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'metaData': MetaDataToJSON(value.metaData),
        'name': value.name,
        'valueType': TagValueTypeToJSON(value.valueType),
        'predefinedValuesOnly': value.predefinedValuesOnly,
        'predefinedValues': value.predefinedValues
    };
}
